import { AgencyDetailsModelAccountType } from '@urbanx/agx.agencies.client';
import { DropdownOption } from '@urbanx/agx.ui-components2';

export const agencyAccountTypeOptions: DropdownOption[] = [
  { value: AgencyDetailsModelAccountType.UrbanX, label: 'Urban X' },
  { value: AgencyDetailsModelAccountType.Autopilot, label: 'Autopilot' },
];
